export type GeneralInfosFields = typeof fields
export const fields = {
  email: "email",
  firstName: "firstName",
  lastName: "lastName",
  phone: "phone",
  status: "status",
  type: "type",
  function: "function",
  teamFunction: "teamFunction",
  externSpecification: "externSpecification",
  programmedUnactivate: "programmedUnactivate",
  unactivateDate: "unactivateDate",
  birthName: "birthName",
  birthDate: "birthDate",
  title: "title",
  rppsId: "rppsId",
} as const
